import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["children"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled, { css } from 'styled-components';
import { color, heightAttributes, marginAttributes, widthAttributes } from '../../system';
import { getPropsBlocker } from '../../utils';
import { transitionDurationInSec } from '../../constants';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = {
  displayMode: true,
  label: true,
  before: true,
  after: true,
  large: true,
  multiline: true,
  outlined: true,
  error: true,
  inside: true,
  outline: true,
  enableFocusOnRootClick: true,
  enableRootRef: true
};

var getDynamicStyle = function getDynamicStyle(nodeName, _ref) {
  var theme = _ref.theme,
      outlined = _ref.outlined,
      error = _ref.error,
      disabled = _ref.disabled,
      large = _ref.large;
  var TextInput = theme.componentOverrides.TextInput;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n        ", "\n    "])), large ? TextInput[nodeName].large : '', outlined ? TextInput[nodeName].outlined : '', error ? TextInput[nodeName].error : '', disabled ? TextInput[nodeName].disabled : '');
};

var getRootDynamicStyle = function getRootDynamicStyle(props) {
  var theme = props.theme,
      displayMode = props.displayMode,
      enableFocusOnRootClick = props.enableFocusOnRootClick;
  var TextInput = theme.componentOverrides.TextInput;
  var result = TextInput.Root.base;

  if (enableFocusOnRootClick) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: text;\n            & > * {\n                cursor: initial;\n            }\n        "])), result);
  }

  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        display: ", ";\n        ", ";\n        ", ";\n    "])), displayMode === 'block' ? 'block' : 'inline-block', result, getDynamicStyle('Root', props));
};

export var TextInputRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    position: relative;\n    border-style: solid;\n    border-width: 1px;\n    transition: border ", "s ease;\n    vertical-align: middle;\n    \n    background-color: ", ";\n\n    ", "\n    ", ";\n    ", "\n    ", "\n    ", "\n"])), transitionDurationInSec, color('neutral.00'), getRootDynamicStyle, getComponentOverride('TextInput'), marginAttributes, widthAttributes, heightAttributes);

var getInnerContainerDynamicStyle = function getInnerContainerDynamicStyle(props) {
  var theme = props.theme,
      multiline = props.multiline;
  var TextInput = theme.componentOverrides.TextInput;
  var result = TextInput.InnerContainer.base;

  if (!multiline) {
    result = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ", ";\n            align-items: center;\n        "])), result);
  }

  return result;
};

export var TextInputInnerContainer = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    ", "\n"])), getInnerContainerDynamicStyle);

var getInputDynamicStyle = function getInputDynamicStyle(props) {
  var theme = props.theme,
      multiline = props.multiline,
      disabled = props.disabled;
  var TextInput = theme.componentOverrides.TextInput;
  var result = TextInput.Input.base;

  if (multiline) {
    result = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            ", ";\n            min-width: ", ";\n        "])), result, multiline ? '100px' : 0);
  }

  if (disabled) {
    result = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            ", ";\n            cursor: not-allowed;\n        "])), result);
  }

  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        ", ";\n        ", ";\n    "])), result, getDynamicStyle('Input', props));
};

var Wrapper = function Wrapper(_ref2) {
  var children = _ref2.children,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  return children(_objectSpread({}, restProps));
};

export var TextInputInput = styled(Wrapper).withConfig(getPropsBlocker(propertyList))(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    border: 0 none;\n    outline: none;\n    appearance: none;\n    flex-grow: 1;\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n    width: 100%;\n\n    ", ";\n"])), getInputDynamicStyle);

var getLabelDynamicStyle = function getLabelDynamicStyle(props) {
  var TextInput = props.theme.componentOverrides.TextInput,
      inside = props.inside,
      large = props.large,
      disabled = props.disabled,
      value = props.value;
  var result = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        ", ";\n        ", ";\n    "])), TextInput.Label.base, getDynamicStyle('Label', props));

  if (!(disabled && value) && inside) {
    result = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            ", ";\n        "])), result, TextInput.Label.inside, large ? TextInput.Label.inside__large : '');
  }

  return result;
};

export var TextInputLabel = styled.span.withConfig(getPropsBlocker(propertyList))(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    position: absolute;\n    text-align: left;\n    overflow-x: hidden;\n    white-space: nowrap;\n    user-select: none;\n    text-overflow: ellipsis;\n    pointer-events: none;\n    transition: top ease ", "s,\n        font-size ease ", "s,\n        color ease ", "s;\n\n    ", "\n"])), transitionDurationInSec, transitionDurationInSec, transitionDurationInSec, getLabelDynamicStyle);

var getLabelBackgroundDynamicStyle = function getLabelBackgroundDynamicStyle(props) {
  var TextInput = props.theme.componentOverrides.TextInput,
      disabled = props.disabled;
  var result = TextInput.LabelBackground.base;
  return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        ", ";\n        background: linear-gradient(\n            0,\n            transparent 0 30%,\n            ", " 30% 70%,\n            transparent 70% 100%\n        );\n        ", ";\n    "])), result, color(disabled ? 'neutral.02' : 'neutral.00'), getDynamicStyle('LabelBackground', props));
};

export var TextInputLabelBackground = styled.span.withConfig(getPropsBlocker(propertyList))(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    ", "\n"])), getLabelBackgroundDynamicStyle);